import React, { useState } from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../../../../components/Icon";
import Modal from "../../../../../../../components/Modal";
import Schedule from "../../../../../../../components/Schedule";
import Actions from "../../../../../../../components/Actions";

const Control = ({
  className,
  actions
}) => {
  const [visibleModal, setVisibleModal] = useState(false);

  // Remplacer l'action "Programmer" par celle qui ouvre notre modal
  const actionsWithModal = actions.map(action => {
    if (action.title === "Programmer") {
      return {
        ...action,
        action: () => setVisibleModal(true),
      };
    }
    return action;
  });

  return (
    <>
      <Actions
        className={cn(styles.control, className)}
        classActionsHead={styles.actionsHead}
        items={actionsWithModal}
        small
      />
      <Modal visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <Schedule />
      </Modal>
    </>
  );
};

export default Control;
